module.exports = __webpack_public_path__ + "img/question@2x.ad50d45a.png";